import { useTheme } from '@emotion/react';
import { AlertCircle, LucideProps } from 'lucide-react';

export const AlertCircleRed = (props: LucideProps) => {
  const theme = useTheme();
  return <AlertCircle {...props} color={theme.palette.secondary.main} />;
};
